(function (exports) {
    "use strict";

    exports.promisify = function promisify(jQueryDeferred) {
        return new Promise(function (resolve, reject) {
            jQueryDeferred.done(resolve).fail(reject);
        });
    };
}(typeof exports === "undefined" ? this.Application = {} : exports));


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/js/application.jasset
 ** module id = 992
 ** module chunks = 0
 **/